  <div class="change-page-buttons">
    <button class="previous-page" (click)="getPreviousPage()" [disabled]="atFirstPage || blockButton">
      <i class="uil uil-arrow-left"></i>
    </button>
    <div class="page-selector-container">
    <mat-form-field class="page-selector">
      <input matInput type="number" [formControl]="currentPageControl" min="1" [max]="pageCount" (blur)="onPageInputBlur()">
      <div></div>
    </mat-form-field>
    <p>de {{ pageCount }}</p>
    </div>
    <button class="next-page" (click)="getNextPage()" [disabled]="atLastPage || blockButton">
      <i class="uil uil-arrow-right"></i>
    </button>
  </div>
  <div class="page-size-selector">
    <div class="label">Itens por página</div>
    <div class="page-size-selector-container">
      <mat-select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
        <mat-option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</mat-option>
      </mat-select>
    </div>
  </div>